import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  BookImageIcon,
  BriefcaseBusinessIcon,
  InfoIcon,
  LandmarkIcon,
  MapPinHouseIcon,
  MountainSnowIcon,
  PlaneTakeoffIcon,
  User2Icon,
  UtensilsIcon,
} from 'lucide-react';

export const DEFAULT_CATEGORY_COLORS = {
  Accommodation: '#2E86AB',
  Activity: '#A23B72',
  Attraction: '#F18F01',
  Destination: '#C73E1D',
  Dining: '#6A994E',
  Information: '#9C89B8',
  Other: '#6C757D',
  Personnel: '#F4A261',
  Transportation: '#264653',
  Venue: '#E76F51',
} as const;

export type CategoryKey = keyof typeof DEFAULT_CATEGORY_COLORS;

export const CATEGORY_CONFIG: ReadonlyArray<{
  key: CategoryKey;
  label: string;
  icon: LucideIcon;
}> = [
  { key: 'Accommodation', label: 'Accommodation', icon: MapPinHouseIcon },
  { key: 'Activity', label: 'Activity', icon: Activity },
  { key: 'Attraction', label: 'Attraction', icon: BookImageIcon },
  { key: 'Destination', label: 'Destination', icon: MountainSnowIcon },
  { key: 'Dining', label: 'Dining', icon: UtensilsIcon },
  { key: 'Information', label: 'Information', icon: InfoIcon },
  { key: 'Other', label: 'Other', icon: BriefcaseBusinessIcon },
  { key: 'Personnel', label: 'Personnel', icon: User2Icon },
  { key: 'Transportation', label: 'Transportation', icon: PlaneTakeoffIcon },
  { key: 'Venue', label: 'Venue', icon: LandmarkIcon },
];

export const CATEGORY_KEYS: ReadonlyArray<CategoryKey> = CATEGORY_CONFIG.map(
  (c) => c.key
);
